export default __webpack_public_path__ + "static/media/welcomeLandingbg-it.050b166f.png";